
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import { BulkInventoryItemListItem } from "@/models/api/barcodeSystem/inventory/bulkInventoryItems";
import { formatDateWithTime, formatBool, formatUoMQuantity } from "@/utils";
import { StockSkuResource } from "@/models/api/barcodeSystem/stockSkus/stockSkus";

const inventoryModuleState = getModule(InventoryModule);

@Component
export default class BulkInventoryItemLocationList extends Vue {
  @Prop({ default: false })
  loading: boolean;

  get otherBulkInventoryItems(): Array<BulkInventoryItemListItem> {
    return inventoryModuleState.otherBulkInventoryItems;
  }

  get selectedItemCount(): number {
    return inventoryModuleState.getSelectedOtherBulkInventoryItemCount;
  }

  get selectedItems(): Array<any> {
    return inventoryModuleState.getSelectedOtherBulkInventoryItems;
  }

  get totalItems() {
    if (inventoryModuleState.otherBulkInventoryItems) {
      return inventoryModuleState.otherBulkInventoryItems.length
    } else {
      return 0;
    }
  }

  getComponentData(rowData) {
    return {
      on: {
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }

  formatDateWithTime(val)
  {
    return formatDateWithTime(val)
  }

  formatBool(val)
  {
    return formatBool(val);
  }

  formatUoMQuantity(val: number, stockSku: StockSkuResource){
    return formatUoMQuantity(val, stockSku);
  }

  onDoubleClicked(data) {
  }

  onRowClick(data) {
    this.unselectAll();
    inventoryModuleState.switchOtherBulkInventoryItemSelectionStatus(data.id);
  }

  unselectAll() {
    let items = this.selectedItems;

    items.forEach(item => {
      inventoryModuleState.switchOtherBulkInventoryItemSelectionStatus(item.id);
    });
  }

  
}
